import React from 'react';
export function Footer() {
  return <footer className="py-6 px-4 sm:px-6 bg-brand-ivory text-center text-brand-text text-xs sm:text-sm border-t border-brand-border" data-id="element-67">
      <p className="leading-snug max-w-xl mx-auto font-medium mb-3" data-id="element-68">
        © 2026 GYMNASTIQUE PRO™ — Tous droits réservés.
        <br data-id="element-69" />
        <br data-id="element-70" />
        Les informations présentées sur ce site sont exclusivement destinées à
        des fins pédagogiques et constituent une ressource professionnelle pour
        les professeurs de gymnastique artistique. Elles ne remplacent ni votre
        expertise, ni les recommandations de votre club, école ou fédération.
        Adaptez toujours les contenus au niveau, aux besoins et aux objectifs de
        vos gymnastes.
      </p>
      <div className="flex justify-center gap-2.5 sm:gap-4 font-heading font-bold tracking-wide uppercase text-brand-navy text-[10px] sm:text-xs" data-id="element-71">
        <a href="#" className="hover:text-brand-violet transition-colors" data-id="element-72">
          Conditions Générales
        </a>
        <span data-id="element-73">•</span>
        <a href="#" className="hover:text-brand-violet transition-colors" data-id="element-74">
          Politique de Confidentialité
        </a>
        <span data-id="element-75">•</span>
        <a href="#" className="hover:text-brand-violet transition-colors" data-id="element-76">
          Contact
        </a>
      </div>
    </footer>;
}